import { Alert } from '@/components/ui/alert'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { SendingDomainResponse } from '@/pages/EmailIdentitySettingsPage.types'
import { SendingDomainLeaseStatus } from '@/components/email-identity/sending-domain-lease-status'

export function SendingDomainDetails({
  viewOnly,
  sendingDomain,
  pending,
  onVerify,
}: {
  viewOnly: boolean
  sendingDomain: NonNullable<SendingDomainResponse['sending_domain']>
  pending: boolean
  onVerify: () => void
}) {
  const verified = sendingDomain.status === 'verified'
  return (
    <div className="space-y-4">
      <SendingDomainLeaseStatus
        domain={sendingDomain.domain}
        status={sendingDomain.status}
        verifiedAt={sendingDomain.verified_at}
        degradedAt={sendingDomain.degraded_at}
        graceEndsAt={sendingDomain.grace_ends_at}
        platformIdentitySince={sendingDomain.platform_identity_since}
      />
      {!verified && Boolean(sendingDomain.policy_warnings?.length) && (
        <Alert variant="warning">
          <p className="font-medium">Email policy warnings</p>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {sendingDomain.policy_warnings?.map((warning) => (
              <li key={warning.code}>{warning.message}</li>
            ))}
          </ul>
        </Alert>
      )}
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="px-2">Record</TableHead>
            <TableHead className="px-2">Host</TableHead>
            <TableHead className="px-2">Value</TableHead>
            <TableHead className="px-2">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sendingDomain.dns_records.map((record) => (
            <TableRow key={record.kind}>
              <TableCell className="px-2 font-medium">{record.type}</TableCell>
              <TableCell className="px-2 font-mono text-caption">{record.host}</TableCell>
              <TableCell className="max-w-64 break-all px-2 font-mono text-caption">
                {record.value}
              </TableCell>
              <TableCell className="px-2">
                <Badge variant={record.verified ? 'success' : 'neutral'}>
                  {record.verified ? 'Verified' : 'Not verified'}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!verified && !viewOnly && (
        <Button type="button" variant="outline" size="sm" onClick={onVerify} disabled={pending}>
          {pending ? 'Verifying...' : 'Verify DNS records'}
        </Button>
      )}
    </div>
  )
}
